import axios, { type InternalAxiosRequestConfig } from "axios";
import { trackApiRequest } from "@/lib/analytics";

// Extend config to carry a start timestamp between request and response interceptors
interface TimedConfig extends InternalAxiosRequestConfig {
  _startTime?: number;
}

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? "http://localhost:4000",
});

// Stamp every outgoing request with its wall-clock start time
apiClient.interceptors.request.use((config: TimedConfig) => {
  config._startTime = Date.now();
  return config;
});

// Track every response — successful or not
apiClient.interceptors.response.use(
  (response) => {
    const cfg = response.config as TimedConfig;
    trackApiRequest(
      cfg.method ?? "GET",
      cfg.url ?? "unknown",
      response.status,
      cfg._startTime ? Date.now() - cfg._startTime : 0,
    );
    return response;
  },
  (error) => {
    // error.config is the original request config; fall back to response.config
    const cfg = (error.config ?? error.response?.config) as TimedConfig | undefined;
    trackApiRequest(
      cfg?.method ?? "GET",
      cfg?.url ?? error.response?.config?.url ?? "unknown",
      error.response?.status ?? 0,
      cfg?._startTime ? Date.now() - cfg._startTime : 0,
    );
    return Promise.reject(error);
  },
);
